var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex items-start pb-2" }, [
    _c("label", { staticClass: "flex items-center h-4 switch" }, [
      _c("input", {
        staticClass: "toggle_checkbox",
        attrs: { id: _vm.id, type: "checkbox" },
        domProps: { checked: _vm.selected },
        on: { change: _vm.updateVal },
      }),
      _vm._m(0),
    ]),
    _c("div", { staticClass: "ml-3 text-sm leading-5" }, [
      _c(
        "label",
        { staticClass: "font-medium text-gray-700", attrs: { for: _vm.id } },
        [
          _c("span", { staticClass: "slider2" }),
          _vm._v(" " + _vm._s(_vm.name) + " "),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("span", { staticClass: "slider round" }, [
      _c("p", { staticClass: "text-xs text-white" }, [_vm._v("ON")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }